import { useMutation } from '@apollo/client';
import type { ApiOptions } from '../helpers';
import { isChannelUnavailable, isSessionExpired } from './errors';
import { TuneRemoteChannelDocument } from './tune-channel.generated';

type TuneRemoteChannelOptions = ApiOptions<typeof TuneRemoteChannelDocument> & {
  /** The channel left the guide, so the page can refetch the list it is offering. */
  onChannelUnavailable?: () => void;
  /** The session ended, so the page can refetch into its expired copy. */
  onSessionExpired?: () => void;
};

/**
 * Raises no snackbar, for the same reason `useSendRemoteCommand` doesn't: a fan gets these states
 * from the page rather than a red bar over the channel they just tapped.
 */
export const useTuneRemoteChannel = ({
  onChannelUnavailable,
  onSessionExpired,
  ...options
}: TuneRemoteChannelOptions = {}) =>
  useMutation(TuneRemoteChannelDocument, {
    ...options,
    // Spread last so a caller's own onError adds to the refetch rather than replacing it.
    onError: (error) => {
      if (isSessionExpired(error)) onSessionExpired?.();
      if (isChannelUnavailable(error)) onChannelUnavailable?.();
      options.onError?.(error);
    },
  });
